// Others
import axiosClient from './axiosClient';
import { IBodyUpdate } from '~/utils/interface/common';
import { urlApiInvoice } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IInvoiceDetail,
  IInvoice,
  IChangeStatusInvoice,
  IParamQueryInvoice,
  IQueryDetailInvoice,
} from '~/utils/interface/invoice';

const invoiceApi = {
  getListInvoice: (params: IParamQueryInvoice) => {
    const url = urlApiInvoice.getListInvoice;
    return axiosClient.get<IBaseResponse<IListDataResponse<IInvoice[]>>>(url, { params });
  },

  getDetailInvoice: (query: IQueryDetailInvoice) => {
    const { id, params } = query;

    const url = urlApiInvoice.getDetailInvoice(id);
    return axiosClient.get<IBaseResponse<IInvoiceDetail>>(url, { params });
  },

  createInvoice: (body: FormData) => {
    const url = urlApiInvoice.createInvoice;
    return axiosClient.post<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  updateInvoice: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiInvoice.updateInvoice(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteInvoice: (id: string) => {
    const url = urlApiInvoice.deleteInvoice(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  sendMailInvoice: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;

    const url = urlApiInvoice.sendMailInvoice(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  changeStatusInvoice: (params: IBodyUpdate<IChangeStatusInvoice>) => {
    const { id, body } = params;
    const url = urlApiInvoice.changeStatusInvoice(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default invoiceApi;
